//CEMEX QA US
// export const environment = {
//   production: false,
//   redirectUrl: 'https://qa.i4safetyus.cemex.com',  
//   clientId: '33114c45-b23d-4f4b-b7ed-6438e139bdbc',
//   tenantName: 'CEMEX',
//   urlBaseService: 'https://qa.i4safetyus.cemex.com/api/',   
//   urlHub: 'https://qa.i4safetyus.cemex.com/Notification',
//   urlHubEventMonitor: 'https://qa.i4safetyus.cemex.com/hub/NotificationI4',
//   authClientId: '',
//   urlAuth: '',
//   urlStorageApi: '',
//   urlScope: 'api://33114c45-b23d-4f4b-b7ed-6438e139bdbc/User.Read',
//   urlPowerBI:"https://powerbi.com/product/schema#basic",
//   siteName: "NONE",
//   isIndustrial: false,
//   isProductionCloud: false
// };

//CEMEX PRD US
// export const environment = {
//   production: false,
//   redirectUrl: 'https://i4safetyus.cemex.com',  
//   clientId: '5c08fea6-8b91-4cb0-bf17-fb3e68d73343',
//   tenantName: 'CEMEX',
//   urlBaseService: 'https://i4safetyus.cemex.com/api/',   
//   urlHub: 'https://i4safetyus.cemex.com/Notification',
//   urlHubEventMonitor: 'https://i4safetyus.cemex.com/hub/NotificationI4',
//   authClientId: '',
//   urlAuth: '',
//   urlStorageApi: '',
//   urlScope: 'api://5c08fea6-8b91-4cb0-bf17-fb3e68d73343/User.Read',
//   urlPowerBI:"https://powerbi.com/product/schema#basic",
//   siteName: "NONE",
//   isIndustrial: false,
//   isProductionCloud: false
// };

//CEMEX QA EU
// export const environment = {
//   production: false,
//   redirectUrl: 'https://qa.i4safetyeu.cemex.com',  
//   clientId: '913eef35-7a2e-4a73-a5f9-263920103019',
//   tenantName: 'CEMEX',
//   urlBaseService: 'https://qa.i4safetyeu.cemex.com/api/',   
//   urlHub: 'https://qa.i4safetyeu.cemex.com/Notification',
//   urlHubEventMonitor: 'https://qa.i4safetyeu.cemex.com/hub/NotificationI4',
//   authClientId: '',
//   urlAuth: '',
//   urlStorageApi: '',
//   urlScope: 'api://913eef35-7a2e-4a73-a5f9-263920103019/User.Read',
//   urlPowerBI:"https://powerbi.com/product/schema#basic",
//   siteName: "NONE",
//   isIndustrial: false,
//   isProductionCloud: false
// };

//CEMEX PRD EU
export const environment = {
  production: false,
  redirectUrl: 'https://i4safetyeu.cemex.com',  
  clientId: 'e1198133-ec9e-48f6-92c6-fc22ed33b7e3',
  tenantName: 'CEMEX',
  urlBaseService: 'https://i4safetyeu.cemex.com/api/',   
  urlHub: 'https://i4safetyeu.cemex.com/Notification',
  urlHubEventMonitor: 'https://i4safetyeu.cemex.com/hub/NotificationI4',
  authClientId: '',
  urlAuth: '',
  urlStorageApi: '',
  urlScope: 'api://e1198133-ec9e-48f6-92c6-fc22ed33b7e3/User.Read',
  urlPowerBI:"https://powerbi.com/product/schema#basic",
  siteName: "NONE",
  isIndustrial: false,
  isProductionCloud: false
};

//PRD NEORIS
// export const environment = {
//   production: true,
//   redirectUrl: 'https://app-ang-prd-eus2-01.azurewebsites.net/',
//   clientId: '3eab9a05-9ae3-44c8-84cb-5f1414d7dcf6',
//   tenantName: 'neoriscloudsaas',
//   urlBaseService: 'https://app-api-prd-eus2-02.azurewebsites.net/api/',
//   urlHub: 'https://app-api-prd-eus2-02.azurewebsites.net/hub/Notification',
//   urlHubEventMonitor: 'https://app-api-prd-eus2-02.azurewebsites.net/NotificationI4',
//   authClientId: '',
//   urlAuth: '',
//   urlStorageApi: '',
//   urlScope: 'api://3eab9a05-9ae3-44c8-84cb-5f1414d7dcf6/User.Read',
//   urlPowerBI:"https://powerbi.com/product/schema#basic"
//   , siteName: "None"
//   , isIndustrial: false
//   , isProductionCloud: true
//  };

//QA NEORIS
// export const environment = {
//   production: false,
//   redirectUrl: 'https://qa.i4safety.ai/api/',  
//   clientId: '35dfb7ce-ce2c-44dc-af10-5fe7eb558bd1',
//   tenantName: 'neoriscloudsaas',
//   urlBaseService: 'https://qa.i4safety.ai/api/',   
//   urlHub: 'https://qa.i4safety.ai/Notification',
//   urlHubEventMonitor: 'https://qa.i4safety.ai/hub/NotificationI4',
//   authClientId: '',
//   urlAuth: '',
//   urlStorageApi: '',
//   urlScope: 'api://35dfb7ce-ce2c-44dc-af10-5fe7eb558bd1/User.Read',
//   urlPowerBI:"https://powerbi.com/product/schema#basic",
//   siteName: "NONE",
//   isIndustrial: false,
//   isProductionCloud: false
// };